class VariablesEnum {
    public static BASE_URL = 'https://journey.liuna506training.ca/'; //'https://sandbox-liuna.azurewebsites.net/';
    public static ABSOLUTE_URL = 'https://liuna506training.ca/';
    public static MIKE_NOVILLO_URL = 'https://www.skilledtradesontario.ca/trade-information/hazardous-materials-worker/#:~:text=A%20Hazardous%20Materials%20Worker%20identifies,pre%2Dcleans%20work%20areas';
    public static HOW_TO_START = 'HOW TO START';
    public static YOUR_CAREER_IN = 'YOUR CAREER IN';
    public static BACK = 'BACK';
    public static RETURN_TO = 'Return to';
    public static TITLE = 'LiUNA Local Training Centre';
    public static MOBILETITLE = 'LiUNA';
    public static MENU = 'MENU';
    public static HOME = 'HOME';
}

export default VariablesEnum
